module.exports = __webpack_public_path__ + "img/score.9ff12114.png";